import { Action, ActionsHubBase } from "DistributedTaskControls/Common/Actions/Base";
import {
    ActionKeys
} from "DistributedTaskControls/SharedControls/InputControls/RepositoryPickerConstants";

export class RepositoryPickerActions extends ActionsHubBase {
    public initialize(): void {
        this._updateValue = new Action<string>();
        this._updateShowRepositorySelectorDialog = new Action<boolean>();
    }

    public get updateValue(): Action<string> {
        return this._updateValue;
    }

    public get updateShowRepositorySelectorDialog(): Action<boolean> {
        return this._updateShowRepositorySelectorDialog;
    }

    public static getKey(): string {
        return ActionKeys.RepositoryPicker;
    }

    private _updateValue: Action<string>;
    private _updateShowRepositorySelectorDialog: Action<boolean>;
}
